import React, { useEffect, useContext, useState } from "react";
import { useAsync } from "react-use";
import { Bas } from "../cms/models/Bas";
import { getData } from "../cms/models/adapters/adapter";
import { LanguageContext } from "./language";

export const STRAPI_URL = window.config.STRAPI_URL;

interface BasContextState {
  bas?: Bas;
}

const useBas = (): Bas => {
  const language = useContext(LanguageContext);
  const [bas, setBas] = useState<Bas>();
  const asyncLoad = async () => {
    try {
      const response = await fetch(
        `${STRAPI_URL}/api/be-a-streamer?populate=deep`
      );
      const basJSON = await response.json();
      const newBas: Bas = await getData<Bas>(basJSON);
      setBas(newBas);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    asyncLoad();
  }, [language.currentLanguage]);
  return bas;
};

export const BasContext = React.createContext<BasContextState>(null);

export const BasContextProvider: React.FC = (props) => {
  const bas = useBas();

  const value = {
    bas,
  };
  return (
    <BasContext.Provider value={value}>{props.children}</BasContext.Provider>
  );
};
